/* -------------------------- Design imports start -------------------------- */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import React, { type ReactElement } from "react";
/* ------------------------- Functional imports end ------------------------- */

interface TimeInputProps {
  id?: string
  label: string
  value: Date | null
  onChange: (value: string) => void
  disabled?: boolean
}
/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function TimeInput(props: TimeInputProps): ReactElement {
  /* -------------------------- Non state data start -------------------------- */
  const { id, label, value, onChange, disabled } = props

  /* --------------------------- Non state data end --------------------------- */

  /* ------------------------ Callback functions start ------------------------ */
  const handleTimeChange = (time: any | null): void => {
    if (time) {
      onChange(time.format('HH:mm:ss'))
    } else {
      onChange('')
    }
  }
  /* ------------------------- Callback functions end ------------------------- */

  /* ------------------------- Render constants start ------------------------- */
  const defaultTime = new Date()
  defaultTime.setHours(0, 0, 0, 0)
  /* -------------------------- Render constants end -------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                              Render component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker']}>
        <TimePicker
          label={label}
          ampm={false}
          value={value || defaultTime}
          onChange={handleTimeChange}
          disabled={disabled}
          views={['hours', 'minutes', 'seconds']}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}
